import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const HeroBlockDescription = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-hero__desc", className)} {...other}>
      {children}
    </div>
  );
};

HeroBlockDescription.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

HeroBlockDescription.defaultProps = {
  className: "",
  children: null
};

export default HeroBlockDescription;
